import React from 'react';
import Grid from '@mui/material/Grid';
import OutlinedInput from '@mui/material/OutlinedInput';
import TextField from '@mui/material/TextField';
import { Select, MenuItem, Paper } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';
import SubmissionPublicationDataTable from './components/submisson-publication-data-table';
import { ISubmissionPublicationDataTableProps } from './components/submisson-publication-data-table';
import DefaultSelectClient from '../../../components/default-select-client';
import { useSubmissionPublicationSearchController } from './context/submission-publication-search-controller';
import { useSubmissionPublicationSearchState } from './context/submission-publication-search-context';
import PageHeader from '../../../components/page-header';

export function SubmissionPublicationSearchComponent() {
    const {
        handleOnChange,
        handleStartDateChange,
        handleEndDateChange
    } = useSubmissionPublicationSearchController();

    const {
        users,
        status,
        datesParameters,
        parameters,
        submissionPublicationId
    } = useSubmissionPublicationSearchState();

    const dataTableProperties: ISubmissionPublicationDataTableProps = {
        parameters: parameters,
        submissionPublicationId: submissionPublicationId
    };

    return (
        <React.Fragment>
            <Grid item xs={12} md={12} lg={12}>
                <PageHeader
                    title="Solicitações de Publicação"
                    subtitle="Gerencie as solicitações de publicação no Diário Oficial"
                    breadcrumbs={[
                        { label: 'SDP', href: '/sdp' },
                        { label: 'Solicitações de Publicação' }
                    ]}
                />
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
                <Paper
                    sx={{
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Grid container spacing={1.5}>
                            <Grid item lg={2} sm={2} xl={2}>
                                <InputLabel>Nº Remessa</InputLabel>
                                <OutlinedInput
                                    type={"number"}
                                    inputProps={{ min: 0 }}
                                    name="input-id"
                                    value={parameters.id}
                                    onChange={handleOnChange}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item lg={3} sm={3} xl={3}>
                                <InputLabel>Status</InputLabel>
                                <Select
                                    label="Status"
                                    name="select-status"
                                    fullWidth
                                    value={parameters.statusId}
                                    multiple
                                    onChange={handleOnChange}
                                >
                                    {status.map((element) => {
                                        return (
                                            <MenuItem value={element.id} key={element.id}>
                                                {element.description}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </Grid>
                            <Grid item lg={3} sm={3} xl={3}>
                                <InputLabel>Tipo de Remessa</InputLabel>
                                <Select
                                    name="select-type"
                                    fullWidth
                                    multiple
                                    value={parameters.types}
                                    onChange={handleOnChange}
                                >
                                    <MenuItem value={1} key={1}>ROTINA</MenuItem>
                                    <MenuItem value={2} key={2}>URGÊNCIA</MenuItem>
                                </Select>
                            </Grid>
                            <Grid item lg={2} sm={2} xl={2}>
                                <InputLabel>Data Envio Inicial</InputLabel>
                                <DesktopDatePicker
                                    inputFormat="DD/MM/YYYY"
                                    maxDate={moment()}
                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                    value={datesParameters.starDatePicker.toDate()}
                                    onChange={handleStartDateChange}
                                />
                            </Grid>
                            <Grid item lg={2} sm={2} xl={2}>
                                <InputLabel>Data Envio Final</InputLabel>
                                <DesktopDatePicker
                                    inputFormat="DD/MM/YYYY"
                                    maxDate={moment()}
                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                    value={datesParameters.endDatePicker.toDate()}
                                    onChange={handleEndDateChange}
                                />
                            </Grid>
                            <Grid item lg={12} sm={12} xl={12}>
                                <InputLabel>Enviada por</InputLabel>
                                <Select
                                    name="select-user-id"
                                    value={parameters.userSenderId ?? ""}
                                    onChange={handleOnChange}
                                    fullWidth
                                >
                                    <MenuItem value="" key={0}>
                                        <em>Nenhum</em>
                                    </MenuItem>
                                    {users.map((element) => {
                                        return (
                                            <MenuItem value={element.id} key={element.id}>
                                                {element.name}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </Grid>
                            <Grid item lg={12} sm={12} xl={12}>
                                <DefaultSelectClient
                                    required={false}
                                    handleOnChange={handleOnChange}
                                    clientId={parameters.clientId}
                                />
                            </Grid>
                        </Grid>
                    </LocalizationProvider>
                </Paper>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
                <Paper
                    sx={{
                        p: 2,
                        minHeight: "500px",
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <SubmissionPublicationDataTable props={dataTableProperties} />
                </Paper>
            </Grid>
        </React.Fragment>
    );
}
